export class Jobs {
    public static readonly AeroPersExportJob: string = 'AeroPersExportJob';
    public static readonly EfaExportJob: string = 'EfaExportJob';
    public static readonly ExportCrewDutyListJob: string = 'ExportCrewDutyListJob';
    public static readonly ExportLogbookJob: string = 'ExportLogbookJob';
    public static readonly CateringReportJob = 'CateringReportJob';
    public static readonly ReleaseScheduleJob = 'ReleaseScheduleJob';
    public static readonly SmsQueueJob = 'SmsQueueJob';
    public static readonly QualityLoopExportJob = 'QualityLoopExportJob';
    public static readonly PeriodPlanningJob = 'PeriodPlanningJob';
}
